<template>
<div>
  <div class="modal-body clearfix">
    <div :class="`tw-rounded-md tw-p-4 tw-mb-4  tw-text-sm ${alertIsValid ? 'tw-text-green-700 tw-bg-green-100' : 'tw-text-red-700 tw-bg-red-100'}`" id="error-boleto" v-if="!validCpf || errors.length > 0 || (!validCpf || patient.needUpdate)">
      <ul id="error-boleto-list">
        <li v-if="!validCpf">
            {{!patient.cpf ? "O paciente não possui CPF cadastrado.": "O CPF é inválido."}}
        </li>
        <li v-for="(error, index) in errors" :key="index">
          {{error}}
        </li>
      </ul>
      <div class="tw-my-4 md:tw-1/2" v-if="!validCpf || patient.needUpdate">
        <cpf-input v-model="patient.cpf" label="CPF do paciente" />
      </div>
    </div>

    <div v-if="!completed" class="tw-bg-white tw-shadow md:tw-shadow-none tw-divide-y md:tw-divide-y-0 tw-divide-gray-200 tw-px-3 md:tw-px-0">
      <div class="row tw-mb-4 tw-text-blue-600 tw-font-semibold tw-hidden md:tw-block">
        <div class="col-md-6">Procedimento</div>
        <div class="col-md-2">Valor</div>
        <div class="col-md-4">Vencimento</div>
      </div>
      <div v-if="debts.length === 0" class="tw-text-center tw-font-bold tw-text-lg tw-my-16">
        Nenhum pagamento selecionado
      </div>
      <div v-for="(debt, index) in debts" :class="`row tw-mb-2 tw-px-4 tw-py-4 md:tw-p-0 ${!debt.valid && 'tw-text-red-500'}`" :key="debt.id">
        <div class="col-md-6 tw-flex tw-items-center" style="margin-top: 6px">
          <img :src="loadingIcon" class="tw-h-5 tw-w-5 tw-mr-2" v-if="processing && !debt.done">
          <img :src="checkIcon" class="tw-h-5 tw-w-5 tw-mr-2" v-if="debt.done">
          <img :src="errorIcon" class="tw-h-5 tw-w-5 tw-mr-2" v-if="!processing && !debt.done && (debt.error || !debt.valid)">
          <div class="">
            <p class="md:tw-hidden tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-1 tw-leading-none">Procedimento</p>
            {{debt.name}}
            <div style="margin-top: 20px" v-if="debt.number_of_payments > 1">
              <span class="tw-text-gray-500 tw-block tw--mt-5">
                {{debt.payment_number}} de {{debt.number_of_payments}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-2 tw-py-4 md:tw-py-0 md:tw-leading-10">
          <p class="md:tw-hidden tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-1 tw-leading-none">Valor</p>
          R$ {{debt.amount_formatted}}
        </div>
        <div class="col-md-4 tw-flex" style="line-height: 40px">
          <div>
            <p class="md:tw-hidden tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-1 tw-leading-none">Data de pagamento</p>
            <custom-date-picker
              :dates="debt.expires_at"
              @dates-submitted="updateDebtExpires(index, debt, arguments[0])"
              format-display="DD/MM/YYYY"
              :show-tomorrow="false"
              :min-date="minDate"
              wrapperClass="btn btn-hover btn-default tw-bg-white tw-px-2 tw-rounded-none tw-w-full tw-text-left">
            </custom-date-picker>
          </div>
          <button @click="removeDebt(debt)" title="Remover pagamento" class="tw-ml-2" v-if="!debt.done && !processing">
            <img :src="closeIcon" class="tw-h-5 tw-w-5 tw-mr-2">
          </button>
        </div>
      </div>
      <label class="tw-mt-5 tw-font-semibold" v-if="debts.length > 1">Agrupar em um boleto cobranças com a mesma data de vencimento</label>
      <div class="admin-form theme-primary" v-if="debts.length > 1">
        <label class="block mt5 switch switch-primary">
          <input type="checkbox" value="yes" v-model="groupSameDate" name="group[same_date]" id="group_same_date">
          <label data-on="SIM" data-off="NÃO" for="group_same_date"></label>
        </label>
      </div>

      <div v-if="processing" class="tw-font-semibold tw-text-center tw-text-lg">Aguarde os boletos estão sendo gerados</div>
        <div v-if="processing" class="tw-w-full tw-bg-gray-200 tw-rounded-full dark:tw-bg-gray-700">
          <div class="tw-bg-blue-600 tw-text-xs tw-font-medium tw-text-blue-100 tw-text-center tw-p-0.5 tw-leading-none tw-rounded-full" :style="`width: ${progress}%`"></div>
        </div>
      </div>
    <iframe :src="boletosUrl()" width="100%" height="600px"  id="show_boleto" v-if="completed"></iframe>
  </div>

  <div class="modal-footer">
    <a type="button" class="tw-mr-5 btn btn-blue-secondary" download :href="boletosUrl(true)" v-if="completed"> <i class="fa fa-download tw-mr-1"></i>Baixar</a>
    <button type="button" class="btn btn-primary" @click="print" v-if="completed">Imprimir</button>
    <button class="btn btn-primary" :disabled="processing || !validForm" @click="startGeneratingBoletos" v-if="!completed">Gerar {{debts.length > 1 ? "boletos" : "boleto" }}</button>
  </div>
</div>
</template>

<script>
  import axios from "axios";
  import uniq from "lodash/uniq"
  import loadingIcon from 'images/spinner.svg';
  import checkIcon from 'images/icons/check-circle-broken-green.svg';
  import errorIcon from 'images/icons/alert-triangle-red.svg';
  import closeIcon from 'images/twenty_twenty_three/icons/x-sm.svg';
  import { addDays, format as formatDate} from 'date-fns'
  import ptBR from "date-fns/locale/pt-BR";
  import CpfInput from './form/cpf-input.vue'
  import validateCpfCnpj from "../helpers/validateCpfCnpj"

  // prevent CSRF error for Rails
  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
  }

  export default {
    props: ["debtsList", "url", "authenticityToken", "patientData", "urlEditPatient", "showBoletoUrl", "hasBoletoApiKey"],
    components: { CpfInput },
    data() {
      const errors = [];
      const debts = JSON.parse(this.debtsList).map(debtItem => {
        const debt = {...debtItem, expires_at: {start: moment(debtItem.expires_at)}, done: false, error: false}
        const valid = this.isDebtValid(debt)
        debt.valid = valid.valid
        if (!valid.valid && !errors.includes(valid.message)) {
          errors.push(valid.message)
        }
        return debt
      });
      const patient = JSON.parse(this.patientData)
      patient.needUpdate = false
      patient.error = false
      patient.valid = true
      return {
        loadingIcon,
        checkIcon,
        errorIcon,
        closeIcon,
        dates: { start: moment().add(1, 'days') },
        processing: false,
        debts,
        currentBoletoIndex: 0,
        completed: false,
        error: false,
        minDate: moment(),
        groupSameDate: true,
        patient,
        progress: 1,
        groupedDebts: {},
        errors
      };
    },
    methods: {
      startGeneratingBoletos(){
        this.processing = true;
        this.errors = []
        this.groupedDebts = [];
        this.updatePatient();
        if (this.groupSameDate) {
          this.groupDebts()
        }
        this.generateBoleto()
      },
      updateBoleto(boleto) {
        this.debts = this.debts.map(debt => {
          if (debt.id != boleto.debt_id) {
            return debt
          }

          debt.boletoPath = boleto.boleto_path
          debt.boletoUrl = boleto.boleto_url
          debt.done = true

          return debt;
        })
      },
      generateBoleto(){
        this.currentBoletoIndex = this.debts.findIndex(debt => !debt.done)

        if (this.currentBoletoIndex === -1) {
          this.completed = true
          this.processing = false
          this.error = false;
          $('#mainModal').on('hidden.bs.modal', function () {
            location.reload();
          })
          return
        }
        this.updateProgressBar()
        const data = {
          authenticity_token: this.authenticityToken,
          boletos: this.getBoletos(),
          group: {same_date: this.groupSameDate ? "yes" : "no"}
        }

        axios.put(this.url, data, {
          headers: {
            "Accept": "application/json"
          }
        })
          .then(({data}) => {
            data.boletos.map(boleto => {
              boleto.debt_ids.map(debt_id => {
                boleto.debt_id = debt_id
                this.updateBoleto(boleto)
              })
            })

            this.debts[this.currentBoletoIndex].done = true
            this.currentBoletoIndex = null
            this.generateBoleto();
          })
          .catch((error) => {
            this.debts[this.currentBoletoIndex].error = true
            this.currentBoletoIndex = null
            this.processing = false
            this.error = true
            if (error.response && error.response.data && error.response.data.error && error.response.data.error.base) {
              this.errors = error.response.data.error.base
            }
            Bugsnag.notify(error);
          });
      },
      updateProgressBar(){
        const total = this.debts.length
        const done = this.debts.filter(debt => debt.done).length
        this.progress = Math.ceil(done/total * 100)
      },
      boletosUrl(download=false){
        let url = this.showBoletoUrl
        if (this.debts.length == 1) {
          url += `?file_name=${this.debts[0].boletoPath}`
        } else {
          const paths = uniq(this.debts.filter((debt) => debt.boletoPath).map(debt => debt.boletoPath))
          url += `?file_names[]=${paths.join('&file_names[]=')}`
        }
        if (download) {
          url += "&download=1"
        }
        return url
      },
      getBoletos(){
        const boletos = []
        const currentDebt = this.debts[this.currentBoletoIndex]
        const boletoExpirationDate = currentDebt.expires_at.start.format("DD/MM/YYYY")
        boletos.push({
          patient_id: currentDebt.patient_id,
          boleto_expiration_date: boletoExpirationDate,
          debt_id: String(currentDebt.id),
        })
        if (this.groupSameDate && this.groupedDebts[boletoExpirationDate]) {
          this.groupedDebts[boletoExpirationDate].map(debt => {
            if (debt.id == currentDebt.id) {
              return
            }
            boletos.push({
              patient_id: debt.patient_id,
              boleto_expiration_date: debt.expires_at.start.format("DD/MM/YYYY"),
              debt_id: String(debt.id),
            })
          })
        }

        return boletos
      },
      groupDebts(){
        this.groupedDebts = [];
        this.debts.map(debt => {
          const expiresAt = debt.expires_at.start.format("DD/MM/YYYY")
          if (!this.groupedDebts[expiresAt]) {
            this.groupedDebts[expiresAt] = []
          }
          this.groupedDebts[expiresAt].push(debt)
        })
      },
      print(){
        document.getElementById('show_boleto').contentWindow.print()
      },
      removeDebt(debt){
        this.debts = this.debts.filter(debtFilter => debtFilter.id != debt.id)
        this.validateDebts();
      },
      validateDebts(){
        this.errors = [];
        this.debts.map(debt => {
          const valid = this.isDebtValid(debt)
          debt.valid = valid.valid
          if (!valid.valid && !this.errors.includes(valid.message)) {
            this.errors.push(valid.message)
          }
          return debt
        });
      },
      isDebtValid(debt){
        const valid = {
          valid: true,
          message: ""
        }

        if (debt.amount < 5) {
          valid.valid = false
          valid.message = "O valor mínimo de um boleto é R$ 5,00"
          return valid
        }
        const today = new Date
        today.setHours(0,0,0,0)
        const limitDate = addDays(today, 820)
        if (debt.expires_at.start.toDate() > limitDate) {
          valid.valid = false
          valid.message = `Não é possível gerar com data superior a ${formatDate(limitDate, "MMMM 'de' yyyy", {
            locale: ptBR
          })}`
          return valid
        }

        if (debt.expires_at.start.toDate() < today) {
          valid.valid = false
          valid.message = "A data de vencimento deve ser maior que hoje."
          return valid
        }

        return valid
      },
      updatePatient(){
        if (!this.patient.needUpdate || !this.validCpf) {
          return false;
        }

        axios.put(`/patients/${this.patient.id}`, {
          authenticity_token: this.authenticityToken,
          patient: {
            cpf: this.patient.cpf
          }
        })
          .then(({data}) => {
            this.patient.error = false
            this.patient.needUpdate = false
          })
          .catch((error) => {
            this.patient.error = true
          });
      },
      updateDebtExpires(debtIndex, debt, expiresAt){
        this.debts[debtIndex].expires_at = expiresAt
        this.validateDebts()
      }
    },
    computed: {
      validForm(){
        if (!this.validCpf || this.debts.length === 0) {
          return false
        }
        const invalidDebts = this.debts.filter(debt => !debt.valid)
        return invalidDebts.length === 0
      },
      validCpf(){
        if (this.patient.error || !this.patient.cpf || this.patient.cpf.length < 14) {
          return false
        }

        return validateCpfCnpj(this.patient.cpf)
      },
      alertIsValid(){
        return this.patient.needUpdate && this.validCpf && this.errors.length === 0
      }
    },
    mounted() {
      this.patient.valid = this.validCpf;
      this.patient.needUpdate = !this.patient.valid;
      this.patient.error = false;
    }
  }
</script>
